"use client";

import { useEffect, useState } from "react";

interface RotatingListProps {
  items: any;
  interval?: number;
  className?: string;
  onChange?: (value: any) => void;
}

const RotatingList = ({ items, interval = 3000, className, onChange }: RotatingListProps) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [processedItems, setProcessedItems] = useState(items);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 550) {
        setProcessedItems(
          items.map((item: { label: string }) => ({
            ...item,
            label: item?.label
              ?.replace(/\(thinking\s*/i, '') // remove "(thinking"
              ?.replace(/[()?]/g, '') // remove characters (,?,)
              ?.trim(),
          }))
        );
      } else {
        setProcessedItems(items); // revert to original items
      }
    };

    handleResize(); // run on initial load
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % processedItems.length);
    }, interval);
    return () => clearInterval(timer);
  }, [processedItems.length, interval]);

  useEffect(() => {
    if (processedItems.length > 0) {
      onChange?.(processedItems[currentIndex]);
    }
  }, [currentIndex, processedItems]);

  return (
    <figure className={className ? `${className}` : ''}>
      <div className="splide">
        <ul className="splide__list">
          <li className="splide__slide transition-opacity duration-500">
            <span dangerouslySetInnerHTML={{ __html: processedItems[currentIndex]?.content }} />
          </li>
        </ul>
      </div>
    </figure>
  );
};

export default RotatingList;
